import React from 'react';
import PropTypes from 'prop-types';

import {
  LoadingNav,
  LoadingImage,
  LoadingImageWithSpinner,
  LoadingDescription,
  LoadingCard,
} from './LoadingComponents';

const LoadingBuildView = ({ isExterior }) => {
  const ColorStrip = () => (
    <div className="color-option color-option-skeleton--loading">
      <LoadingImage className="color-option__image--loading" />
      <div className="color-option__description-container">
        <LoadingDescription className="loading-description--color-strip-option" />
      </div>
    </div>
  );

  return (
    <>
      <LoadingNav />
      <div className="buildview-content-container">
        <div className="buildview-cgi__container buildview-cgi-container--loading">
          <LoadingImageWithSpinner />
        </div>
        <section className="selection-container">
          {isExterior ? (
            <div className="exterior-color-container">
              <ColorStrip />
              <ColorStrip />
              <ColorStrip />
              <ColorStrip />
              <ColorStrip />
              <ColorStrip />
            </div>
          ) : (
            <div className="option-grid">
              <LoadingCard type="option-card" />
              <LoadingCard type="option-card" />
              <LoadingCard type="option-card" />
              <LoadingCard type="option-card" />
              <LoadingCard type="option-card" />
              <LoadingCard type="option-card" />
            </div>
          )}
        </section>
      </div>
    </>
  );
};

LoadingBuildView.defaultProps = {
  isExterior: false,
};

LoadingBuildView.propTypes = {
  isExterior: PropTypes.bool,
};

export default LoadingBuildView;
